// adaptors/axios.ts
import axios from "axios";
var $http = /* @__PURE__ */ axios.create({});
var axiosAdaptor = Object.preventExtensions({
  get default() {
    return $http;
  },
  responseWrapper: {},
  get(url, options) {
    return $http.get(url, options);
  },
  post(url, options) {
    const { data, ...config } = options || {};
    return $http.post(url, data, config);
  },
  put(url, options) {
    const { data, ...config } = options || {};
    return $http.put(url, data, config);
  },
  delete(url, options) {
    const { ...config } = options || {};
    return $http.delete(url, config);
  },
  patch(url, options) {
    const { data, ...config } = options || {};
    return $http.patch(url, data, config);
  }
});
var axios_default = axiosAdaptor;
export {
  axiosAdaptor,
  axios_default as default
};
